import { PrismicRichText } from '@prismicio/react';
import { Button } from '@remote-com/norma/core/button';
import Image from 'next/image';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { fieldHasContent, transformProperties } from 'remote-com-shared/domains/prismic/helpers';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

import { tabletBreakpoint } from '@/src/domains/shared/breakpoints';

const Section = styled.section`
  ${fluidProp(['padding-top', 'padding-bottom'], '100px', '200px')};
  background-color: var(--colors-royalPurple);
  position: relative;
  overflow: hidden;
`;

export const Title = styled.div`
  ${({ theme }) => theme.typography.scale2};
  ${fluidProp('font-size', '36px', '52px')};
  max-width: 550px;
  color: var(--colors-blank);
  margin-bottom: 57px;

  strong {
    color: var(--colors-turquoise);
    font-weight: 600;
  }

  & > * {
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    margin: inherit;
  }
`;

const CTAButton = styled(Button)`
  && {
    border-color: var(--colors-turquoise);
    background-color: transparent;
  }
`;

export const IllustrationWrapper = styled.div`
  position: absolute;
  right: 0;
  bottom: -16%;
  max-width: 60%;

  ${tabletBreakpoint(css`
    display: none;
  `)};
`;

export function GetYourGuideSlice({ slice }) {
  const { primary } = transformProperties(slice);
  const { title, ctaLabel, ctaLink, illustration } = primary;

  return (
    <Section>
      <ContentContainer>
        {fieldHasContent(title) && (
          <Title>
            <PrismicRichText field={title} />
          </Title>
        )}
        {ctaLink && ctaLabel && (
          <CTAButton href={ctaLink?.url} target={ctaLink?.target}>
            {ctaLabel}
          </CTAButton>
        )}
        {illustration && (
          <IllustrationWrapper>
            <Image
              src={illustration?.url}
              alt={illustration?.alt || ''}
              width={illustration?.dimensions.width}
              height={illustration?.dimensions.height}
              quality="100"
            />
          </IllustrationWrapper>
        )}
      </ContentContainer>
    </Section>
  );
}
